import React, { useEffect, useState } from "react";
import { Form, Input, Row, Col, Card, Select, DatePicker, Button, Typography, Tag, Tooltip } from "antd";
import {
    UserOutlined, BankOutlined, EnvironmentOutlined, FileTextOutlined,
    IdcardOutlined, PlusOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import useMessage from "antd/es/message/useMessage";
import { DepartmentEmpServices } from "../../../Services/Manage/DepartmentEmpServices";
import { UserService } from "../../../Services/Manage/UserService";
import { AddEmployeesService } from "../../../Services/Manage/AddEmployeesService";
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ConfigurationService } from "../../../Services/Manage/ConfigurationService";

const { TextArea } = Input;

const PRIMARY = "rgba(11, 93, 148, 0.95)";

const CardTitle = ({ icon, text }) => (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8, color: PRIMARY }}>
        {icon}
        <span style={{ fontWeight: 600 }}>{text}</span>
    </span>
);

const compactStyle = `
  .se-form .ant-form-item { margin-bottom: 14px !important; }
  .se-form .ant-card-body { padding: 16px !important; }
  .se-form .ant-card { margin-bottom: 16px !important; }
  .se-form .ant-form-item-label { padding-bottom: 2px !important; }
`;

const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
];
const maritalOptions = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
    { value: "Other", label: "Other" },
];
const employeeTypeOptions = [
    { value: "Full-time", label: "Full-time" },
    { value: "Part-time", label: "Part-time" },
    { value: "Contract", label: "Contract" },
    { value: "Intern", label: "Intern" },
];
const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
];


// const shiftOptions = [
//     { value: "Day", label: "Day" },
//     { value: "Night", label: "Night" },
//     { value: "Rotational", label: "Rotational" },
// ];

const getPermission = (link) => {
    try {
        const raw = localStorage.getItem("ome_permission");
        const parsed = JSON.parse(raw);
        const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
        return permissions.find((p) => p.link === link) || { add: false, edit: false, delete: false, read: false };
    } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const CreateEmployees = () => {
    const perm = getPermission("/add-employees");
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [apiMessage, msgContext] = useMessage();
    const [allManagers, setAllManagers] = useState([]);
    const [roleOptions, setRoleOptions] = useState([]);
    const [deptOptions, setDeptOptions] = useState([]);
    const [managerOptions, setManagerOptions] = useState([]);
    const [generatedUid, setGeneratedUid] = useState('');
    const [profilePhoto, setProfilePhoto] = useState(null);
    const [newDesignation, setNewDesignation] = useState('');
    const [newDepartment, setNewDepartment] = useState('');


    const [countries, setCountries] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);


    const [optionTerritory, setOptionTerritory] = useState([]);
    const [optionLeadSourceFocus, setOptionLeadSourceFocus] = useState([]);
    const [optionWorkLocation, setOptionWorkLocation] = useState([]);
    const [optionShift, setOptionShift] = useState([]);

    const loadRoles = async () => {
        try {
            const res = await DepartmentEmpServices.getAllRoles();
            setRoleOptions(
                (res.data || [])
                    .filter((r) => r.status === "Active")
                    .map((r) => ({ value: r.name, label: r.name }))
            );
        } catch (e) { console.error(e); }
    };

    const loadDepartments = async () => {
        try {
            const res = await DepartmentEmpServices.getAllDepartment();
            setDeptOptions(
                (res.data || [])
                    .filter((d) => d.status === "Active")
                    .map((d) => ({ value: String(d.id), label: d.name, name: d.name }))
            );
        } catch (e) { console.error(e); }
    };

    const loadManagers = async () => {
        try {
            const res = await UserService.getAllUsers();
            const active = (res.data || [])
                .filter((u) => u.status === "Active")
                .map((u) => ({
                    value: u.name,
                    label: `${u.name}${u.user_id ? ` (${u.user_id})` : ""}`,
                    department_id: String(u.department_id),
                }));
            setAllManagers(active);
            setManagerOptions(active);
            console.log("managers", active); // add here
        } catch (e) { console.error(e); }
    };

    const handleValuesChange = (changedValues) => {
        if ("department_id" in changedValues) {
            const depts = form.getFieldValue("department_id") || [];
            if (depts.length > 0) {
                const filtered = allManagers.filter((u) =>
                    (u.department_id || "").split(",").some(id => depts.includes(id.trim()))
                );
                setManagerOptions(filtered.length > 0 ? filtered : allManagers);

            } else {
                setManagerOptions(allManagers);
            }
            form.setFieldValue("reporting_manager", undefined);
        }
    };

    const generateUid = async () => {
        try {
            const res = await UserService.getLastUsers();
            const now = new Date();
            const day = String(now.getDate()).padStart(2, "0");
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const currentPrefix = `${day}${month}`;
            let nextNumber = "0001";
            if (res.data?.uid) {
                const lastPrefix = res.data.uid.split("-")[0];
                if (lastPrefix === currentPrefix) {
                    const numericPart = res.data.uid.split("-")[1] || "0000";
                    nextNumber = String(Number(numericPart) + 1).padStart(4, "0");
                }
            }
            setGeneratedUid(`${currentPrefix}-${nextNumber}`);
        } catch (e) { console.error(e); }
    };

    const handleAddDesignation = async () => {
        if (!newDesignation.trim()) return;
        try {
            const res = await DepartmentEmpServices.createRole({ name: newDesignation.trim(), status: "Active" });
            if (res.status) {
                await loadRoles();
                form.setFieldValue("designation", newDesignation.trim());
                setNewDesignation('');
            }
        } catch (e) { console.error(e); }
    };

    const handleAddDepartment = async () => {
        if (!newDepartment.trim()) return;
        try {
            const res = await DepartmentEmpServices.createDepartment({ name: newDepartment.trim(), status: "Active" });
            if (res.status) {
                await loadDepartments();
                form.setFieldValue("department_id", [String(res.data?.id)]);
                setNewDepartment('');
            }
        } catch (e) { console.error(e); }
    };

    const loadEmployeeConfigs = async () => {
        try {
            const [territory, focus, location, shift] = await Promise.all([
                ConfigurationService.getByType("territory"),
                ConfigurationService.getByType("lead_source_focus"),
                ConfigurationService.getByType("work_location"),
                ConfigurationService.getByType("shift"),
            ]);
            setOptionTerritory((territory.data || []).map(i => ({ value: i.label, label: i.label })));
            setOptionLeadSourceFocus((focus.data || []).map(i => ({ value: i.label, label: i.label })));
            setOptionWorkLocation((location.data || []).map(i => ({ value: i.label, label: i.label })));
            setOptionShift((shift.data || []).map(i => {
                let durationStr = "";
                if (i.start_time && i.end_time) {
                    const start = dayjs(i.start_time, "hh:mm A");
                    let end = dayjs(i.end_time, "hh:mm A");
                    if (end.isBefore(start)) end = end.add(1, "day");
                    const minutes = end.diff(start, "minute");
                    const hrs = Math.floor(minutes / 60);
                    const mins = minutes % 60;
                    durationStr = mins > 0 ? ` (${hrs}h ${mins}m)` : ` (${hrs}h)`;
                }
                return {
                    value: i.label,
                    label: i.start_time && i.end_time
                        ? `${i.label} (${i.start_time} – ${i.end_time})${durationStr}`
                        : i.label,
                };
            }));
        } catch (e) { console.error(e); }
    };


    useEffect(() => {
        loadRoles();
        loadDepartments();
        loadManagers();
        generateUid();
        getAllCountries();
        loadEmployeeConfigs();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFinish = async (values) => {
        const selectedDepts = deptOptions.filter((d) => (values.department_id || []).includes(d.value));
        const user = await UserService.getOmeUser();

        const payload = {
            ...values,
            uid: generatedUid,
            department_id: values.department_id ? values.department_id.join(",") : null,
            department_name: selectedDepts.map(d => d.name).join(",") || null,
            dob: values.dob ? dayjs(values.dob).format("YYYY-MM-DD") : null,
            date_of_joining: values.date_of_joining
                ? dayjs(values.date_of_joining).format("YYYY-MM-DD")
                : null,
            added_by: user.uid,
        };

        const formData = new FormData();

       Object.entries(payload).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    formData.append(key, value);
});

        if (profilePhoto) {
            formData.append("profile_photo", profilePhoto);
        }

        try {
            const req = await AddEmployeesService.create(formData);
            if (req.status) {
                apiMessage.success(req.message);
                form.resetFields();
                form.setFieldsValue({ status: "Active" });
                setProfilePhoto(null);
            } else {
                apiMessage.error(req.message);
            }
        } catch (e) {
            console.error(e);
            apiMessage.error("Failed to save employee");
        }
    };

    const getAllCountries = async () => {
        try {
            const res = await fetch("https://countriesnow.space/api/v0.1/countries/states");
            const json = await res.json();
            const list = (json.data || []).map((c) => ({
                value: c.name,
                label: c.name,
                states: (c.states || []).map((s) => ({ value: s.name, label: s.name })),
            }));
            setCountries(list);
        } catch (e) { console.error(e); }
    };

    const handleCountryChange = (countryName) => {
        const c = countries.find((x) => x.value === countryName);
        setStateOptions(c ? c.states : []);
        form.setFieldValue("state", null);
    };

    return (
        <>
            {msgContext}
            <style>{compactStyle}</style>
            <Card
                title={
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontWeight: 600, fontSize: 20 }}>
                            Add Employees{generatedUid ? ` — ${generatedUid}` : ""}
                        </span>
                    </span>
                }
                style={{ marginBottom: 16 }}
            >

                <Form
                    form={form}
                    layout="vertical"
                    size="middle"
                    className="se-form"
                    onFinish={handleFinish}
                    initialValues={{ status: "Active" }}
                    onValuesChange={handleValuesChange}
                >
                    <Row gutter={16}>
                        {/* Personal Information */}
                        <Col xs={24} lg={12}>
                            <Card title={<CardTitle icon={<UserOutlined />} text="Personal Information" />}>
                                <Row gutter={16}>
                                    <Col xs={24} md={8}>
                                        <Form.Item label="Employee ID">
                                            <Input
                                                size="large"
                                                value={generatedUid}
                                                placeholder="Auto Generate"
                                                readOnly
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={8}>
                                        <Form.Item name="name" label="Employee Name"
                                            rules={[{ required: true, message: "Please enter name" }]}>
                                            <Input size="large" placeholder="Enter full name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item name="dob" label="Date of Birth">
                                            <DatePicker size="large" style={{ width: "100%" }} format="DD-MM-YYYY"
                                                placeholder="Select date of birth" />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={8}>
                                        <Form.Item name="mobile_no" label="Mobile Number"
                                            rules={[{ required: true, message: "Please enter mobile number" }]}>
                                            <Input size="large" placeholder="Enter mobile number" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item name="email" label="Email Address"
                                            rules={[{ type: "email", message: "Enter a valid email" }, { required: true, message: "Please enter email" }]}>
                                            <Input size="large" placeholder="Enter email address" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item name="alt_mobile_no" label="Alternate Mobile Number">
                                            <Input size="large" placeholder="Enter alternate number" />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={8}>
                                        <Form.Item name="gender" label="Gender">
                                            <Select size="large" showSearch allowClear options={genderOptions} placeholder="Select gender"
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item name="marital_status" label="Marital Status">
                                            <Select size="large" showSearch allowClear options={maritalOptions} placeholder="Select marital status"
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item name="nationality" label="Nationality">
                                            <Input size="large" placeholder="Enter nationality" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        {/* Job Information */}
                        <Col xs={24} lg={12}>
                            <Card title={<CardTitle icon={<IdcardOutlined />} text="Job Information" />}>
                                <Row gutter={16}>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="designation" label="Designation"
                                            rules={[{ required: true, message: "Please select designation" }]}>
                                            <Select
                                                size="large" showSearch allowClear
                                                placeholder="Select designation"
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())}
                                                options={roleOptions}
                                                dropdownRender={(menu) => (
                                                    <>
                                                        {menu}
                                                        <div style={{ display: "flex", gap: 8, padding: "8px 4px" }}>
                                                            <Input
                                                                size="small"
                                                                placeholder="Add new designation"
                                                                value={newDesignation}
                                                                onChange={(e) => setNewDesignation(e.target.value)}
                                                                onKeyDown={(e) => e.stopPropagation()}
                                                            />
                                                            <Button size="small" type="primary" icon={<PlusOutlined />} onClick={handleAddDesignation}>
                                                                Add
                                                            </Button>
                                                        </div>
                                                    </>
                                                )}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="department_id" label="Department"
                                            rules={[{ required: true, message: "Please select department" }]}>
                                            <Select
                                                mode="multiple"
                                                size="large" showSearch allowClear
                                                placeholder="Select department"
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())}
                                                options={deptOptions}
                                                dropdownRender={(menu) => (
                                                    <>
                                                        {menu}
                                                        <div style={{ display: "flex", gap: 8, padding: "8px 4px" }}>
                                                            <Input
                                                                size="small"
                                                                placeholder="Add new department"
                                                                value={newDepartment}
                                                                onChange={(e) => setNewDepartment(e.target.value)}
                                                                onKeyDown={(e) => e.stopPropagation()}
                                                            />
                                                            <Button size="small" type="primary" icon={<PlusOutlined />} onClick={handleAddDepartment}>
                                                                Add
                                                            </Button>
                                                        </div>
                                                    </>
                                                )}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={12}>
                                        <Form.Item name="reporting_manager" label="Reporting Manager"
                                        >
                                            <Select size="large" showSearch allowClear options={managerOptions}
                                                placeholder="Select reporting manager"
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="date_of_joining" label="Date of Joining"
                                            rules={[{ required: true, message: "Please select joining date" }]}>
                                            <DatePicker size="large" style={{ width: "100%" }} format="DD-MM-YYYY"
                                                placeholder="Select joining date" />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={12}>
                                        <Form.Item name="employee_type" label="Employee Type"
                                            rules={[{ required: true, message: "Please select employee type" }]}>
                                            <Select size="large" showSearch allowClear options={employeeTypeOptions}
                                                placeholder="Select employee type"
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="status" label="Status"
                                            rules={[{ required: true, message: "Please select status" }]}>
                                            <Select size="large" showSearch allowClear options={statusOptions} placeholder="Select status"
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        {/* Work Information */}
                        <Col xs={24} lg={12} style={{ display: "flex" }}>
                            <Card style={{ width: "100%" }} title={<CardTitle icon={<BankOutlined />} text="Work Information" />}>
                                <Row gutter={16}>
                                    <Col xs={24} md={12}>
                                    <Form.Item name="territory" label="Territory (Configuration)" rules={[{ required: true, message: "Please enter territory" }]}>
                                            <Select
                                                size="large" showSearch allowClear placeholder="Select territory"
                                                options={optionTerritory}
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                     <Form.Item name="lead_source_focus" label="Lead Source / Service Focus (Configuration)">
                                            <Select size="large" showSearch allowClear placeholder="Select lead source / service focus"
                                                options={optionLeadSourceFocus}
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                 <Form.Item name="work_location" label="Work Location (Configuration)">
                                            <Select size="large" showSearch allowClear placeholder="Select work location"
                                                options={optionWorkLocation}
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="employee_code" label="Employee Code (Payroll)">
                                            <Input size="large" placeholder="Enter employee code" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                              <Form.Item name="working_shift" label="Working Hours / Shift (Configuration)">
                                            <Select
                                                size="large" showSearch allowClear
                                                placeholder="Select working shift"
                                                options={optionShift}
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="access_role" label="Access Role" rules={[{ required: true, message: "Please select access role" }]}>

                                            <Select size="large" showSearch allowClear options={roleOptions}
                                                placeholder="Select access role"
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        {/* Contact & Address */}
                        <Col xs={24} lg={12} style={{ display: "flex" }}>
                            <Card style={{ width: "100%" }} title={<CardTitle icon={<EnvironmentOutlined />} text="Contact & Address" />}>
                                <Row gutter={16}>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="address_line1" label="Address Line 1">
                                            <Input size="large" placeholder="Enter address line 1" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="address_line2" label="Address Line 2">
                                            <Input size="large" placeholder="Enter address line 2" />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={8}>
                                        <Form.Item name="country" label="Country" rules={[{ required: true, message: "Please select country" }]}>
                                            <Select
                                                size="large" showSearch allowClear
                                                placeholder="Select country"
                                                options={countries}
                                                onChange={handleCountryChange}
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item name="state" label="State" rules={[{ required: true, message: "Please select state" }]}>
                                            <Select
                                                size="large" showSearch allowClear
                                                placeholder="Select state"
                                                options={stateOptions}
                                                filterOption={(i, o) => (o?.label ?? "").toLowerCase().includes(i.toLowerCase())}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={8}>
                                        <Form.Item name="city" label="City" rules={[{ required: true, message: "Please enter city" }]}>
                                            <Input size="large" placeholder="Enter city" />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={8}>
                                        <Form.Item name="pincode" label="Pincode" rules={[{ required: true, message: "Please enter pincode" }]}>
                                            <Input size="large" placeholder="Enter pincode" />
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </Card>
                        </Col>

                        {/* Additional Information */}
                        <Col xs={24}>
                            <Card title={<CardTitle icon={<FileTextOutlined />} text="Additional Information" />}>
                                <Row gutter={16}>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="skills" label="Skills / Expertise">
                                            <Input size="large" placeholder="Enter skills or expertise" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item name="remarks" label="Remarks">
                                            <TextArea rows={1} style={{ minHeight: 40 }} placeholder="Enter remarks (optional)" />
                                        </Form.Item>
                                    </Col>

                                </Row>
                                <Col xs={24} md={12}>
                                    <Form.Item label="Profile Photo">
                                        <Upload
                                            maxCount={1}
                                            fileList={profilePhoto ? [{
                                                uid: profilePhoto.uid || "-1",
                                                name: profilePhoto.name,
                                                status: "done",
                                                originFileObj: profilePhoto,
                                            }] : []}
                                            beforeUpload={(file) => {
                                                const fileWithUid = file;
                                                fileWithUid.uid = file.uid || "-1";
                                                setProfilePhoto(fileWithUid);
                                                return false;
                                            }}
                                            onRemove={() => setProfilePhoto(null)}
                                            accept="image/*"
                                        >
                                            <Button icon={<UploadOutlined />}>
                                                Upload Photo
                                            </Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                            </Card>
                        </Col>
                    </Row>

                    <div style={{ textAlign: "right", marginTop: 8 }}>
                        <Button onClick={() => navigate(-1)} size="large"
                            style={{ marginRight: 8, color: PRIMARY, borderColor: PRIMARY }}>
                            Cancel
                        </Button>
                        <Tooltip title={!perm.add ? "You don't have permission to create" : ""}>
                            <Button type="primary" htmlType="submit" size="large" disabled={!perm.add}
                                style={{ background: PRIMARY, borderColor: PRIMARY }}>
                                Save Employee
                            </Button>
                        </Tooltip>
                    </div>
                </Form>
            </Card>
        </>
    );
};

export default CreateEmployees;